import { styled } from '@mui/material/styles'
import {Box} from "@mui/material";

export const NoWrap = styled(Box)({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontWeight:500,
});
